import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './ProductionRecords.css';
import { api } from '../services/db';

export default function ProductionRecords() {
    const { warehouseId } = useAuth();
    const [productionData, setProductionData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (warehouseId) loadData();
    }, [warehouseId]);

    async function loadData() {
        setLoading(true);
        const data = await api.getProductionRecords(warehouseId);
        setProductionData(data);
        setLoading(false);
    }



    return (
        <div className="records-root" dir="rtl">
            <Link to="/production"><button id="back-btn">رجوع</button></Link>
            <div className="container">
                <div className="card">
                    <h2>السجلات</h2>
                    {loading ? <p>جاري التحميل...</p> : (
                        <table id="recordsTable">
                            <thead>
                                <tr>
                                    <th>التاريخ</th>
                                    <th>جوالات 5 كيلو</th>
                                    <th>جوالات 10 كيلو</th>
                                    <th>جوالات 50 كيلو مستهلكة</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Appwrite returns results, we map them. Note keys might differ. 
                                date, sack_size (type), quantity (count), total_weight, consumed_50kg */}
                                {[...productionData].sort((a, b) => new Date(b.date) - new Date(a.date)).map(item => {
                                    const c5 = item.sack_size === 5 ? item.quantity : '';
                                    const c10 = item.sack_size === 10 ? item.quantity : '';
                                    return (
                                        <tr key={item.$id}>
                                            <td>{new Date(item.date).toLocaleDateString('en-GB')}</td>
                                            <td>{c5}</td>
                                            <td>{c10}</td>
                                            <td>{item.consumed_50kg}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}
